import bgImage from '../../assets/moneybank.png' 

export default function About(){
    return(
        <section
        id='about'
        className="about-section pt-120 pb-120 bg_img"
        data-background={bgImage}
      >
        <div className="container">
          <div className="row">
         <div className='col-md-6'>
            <img style={{marginLeft:'20%', marginRight:'25%' , marginTop:'-50px', borderRadius:'20px'}} width={'70%'} src='https://life2.io/wp-content/uploads/2023/05/IMG_4648.60e0915d49e7d376e0a7-1.gif' alt='..' />
            {/* <iframe src="https://app.vectary.com/p/1e8UtgqYjeQ1Yhd02sQR6N" frameborder="0" width="100%" height="480"></iframe> */}
            </div>
         {/* offset-lg-6 */}
            <div className="col-md-6 ">
              <div className="about-content">
                <h2  className="section-title mb-3">
                  {/* <span className="font-weight-normal">Win</span>{" "} */}
                  <span style={{color:'white'}} className="base--color">Win</span>{" "}
                  <b className="base--color">$100K </b>
                </h2>
                <h3>Worth of Globus Smart Coins (GLSC)!</h3>
                <p>
                  That’s right, we’re giving 5 lucky person the chance to win $100k worth of GLSC. To enter, simply follow the steps in the competition box, or follow the steps below.
                </p>
              
                <p className="mt-4">
                We want to give our community the best possible chance to win this prize, that’s why we’ve given you not one, not two, but nine ways to enter our competition.
                
                </p>
                {/* <a href="#" className="cmn-btn mt-4">
                  MORE INFO
                </a> */}
              </div>
              {/* about-content end */}
            </div>
          </div>
        </div>
      </section>      
    );
}